module.exports = __webpack_public_path__ + "static/media/1992-Impreza-GF.ef91925d.jpeg";